import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild, Router} from "@angular/router";

@Injectable()
export class AuthGuard implements CanActivateChild, CanActivate {
    constructor(private router: Router) {}
    canActivate():boolean {
        if(localStorage.getItem("IsAdmin") === "true"){
            return true;
        }
        this.router.navigate(['/access-denied']);
        return false;
    }
    canActivateChild():boolean {
        return this.canActivate();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/auth-admin.guard.ts